import React from 'react';
import styled from 'styled-components';
import { Box } from '@slope/uikit';

const Card = styled.div.attrs<{ 'data-club-slug'?: string }>((props) => ({
  'data-club-slug': props['data-club-slug'],
}))<{ 'data-club-slug'?: string }>`
  cursor: default;
  transition: all 0.3s ease;
  border: 2px solid transparent;
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  min-width: 280px;

  @supports (view-transition-name: none) {
    view-transition-name: ${(props) =>
      props['data-club-slug'] ? `club-card-${props['data-club-slug']}` : 'none'};
  }
`;

const SkeletonBox = styled.div<{ width?: string; height?: string; marginBottom?: string }>`
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s ease-in-out infinite;
  border-radius: 4px;
  width: ${(props) => props.width || '100%'};
  height: ${(props) => props.height || '20px'};
  margin-bottom: ${(props) => props.marginBottom || '0'};

  @keyframes loading {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`;

export interface ClubCardSkeletonProps {
  'data-club-slug'?: string;
}

export const ClubCardSkeleton: React.FC<ClubCardSkeletonProps> = ({ 'data-club-slug': slug }) => {
  return (
    <Card data-club-slug={slug}>
      <Box p="1.5rem">
        <SkeletonBox width="80%" height="24px" marginBottom="0.5rem" />
        <SkeletonBox width="50%" height="16px" marginBottom="2rem" />
        <SkeletonBox width="100%" height="40px" />
      </Box>
    </Card>
  );
};
